import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/views/index';
import Compare from '@/views/compare';
import Result from '@/views/result';
// import { debug } from 'util';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      adobe: {
        page: 'crossfleet solutions',
      },
    },
  },
  {
    path: '/result-and-expectation',
    name: 'Result',
    component: Result,
    meta: {
      adobe: {
        page: 'result and expectation',
      },
    },
  },
  {
    path: '/time-lapse',
    name: 'Compare',
    component: Compare,
    meta: {
      adobe: {
        page: 'time-lapse',
      },
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

// set a random initial date so that the first page will load
let lastRouteUpdateTime;
const allowRouteBuffer = 500; // 500ms or 0.5 sec to allow a second route.


/** Global handler for loading spinner
 *  implemented at the route level
 */
router.beforeEach((to, from, next) => {
  // console.log(`Try to route from ${from.name} to ${to.name}`);
  // Set a buffer here to only allow route to be set after a time buffer
  const currentRouteUpdateTime = Date.now();
  const timeFromLastRoute = lastRouteUpdateTime ?
    currentRouteUpdateTime - lastRouteUpdateTime : currentRouteUpdateTime;
  // console.log(`time from last route: ${timeFromLastRoute}ms`);

  if (timeFromLastRoute < allowRouteBuffer) {
    // console.log(`Route abort - Time from last route is ${timeFromLastRoute}ms < ${allowRouteBuffer}ms`);
    next(false); // abort route because user click to other route too quickly
    return;
  }
  lastRouteUpdateTime = currentRouteUpdateTime;
  // console.log('proceed to next route');
  // console.log(`Before each route ${from.name} to ${to.name}`);
  window.loadSpinner = true;

  // If route are the same, there is no need to preload or prefetch anything and BeforeRouteEnter
  // will not be triggered.  NOTE: if there is a need to handle query logic, then use beforeRouteUpdate.
  if (to.name !== from.name) {
    // console.log(`Preloading - because to and from are the same: ${to.name === from.name}`);
    // wait 1.5 sec before activate a spinner.
    // if loadSpinner is still true after 1.5 sec, activate spinner,
    // if route is successfully entered, loadSpinner would have been set by afterEach below
    setTimeout(() => {
      if (window.loadSpinner === true) {
        // NOTE: The dom may not be ready if it is a fresh load (refresh)
        // But if we have an existing page, then the loadingScreen will be here
        // @see 'router-view-loaded' event to hide loadingScreen
        if (document.getElementById('loadingScreen')) {
          document.getElementById('loadingScreen').style.visibility = 'visible';
        }
      }
    }, 1500);
  } else {
    // console.log(`No preloading - because to and from are the same: ${to.name === from.name}`);
  }
  next();
});

router.afterEach((to, from) => {
  // console.log(`After each route ${from.name} to ${to.name}`);
  if (window.routeHistory[window.routeHistory.length - 1] === to.name) {
    window.routeHistory.pop();
  } else if (from.name) {
    window.routeHistory.push(from.name);
  }
  window.fromRoute = from;
  window.toRoute = to;

  // This is to force a Hashchange event so Chris Gordon script can detect a route change
  // thus report adobe analytics.  Initially, the adobe analytic call is handled within Vue app
  // but the request to report event is not created properly as we lack the ability to understand
  // what's in the library, thus we use Chris generic code to handle page load analytics.  Nonethelss,
  // the compare.vue page still report video tracking using the libraray imported by Chris adobe_dtm
  // in the index.html file
  if (!window.firstLaunch) {   
    setTimeout(()=>{window.dispatchEvent(new HashChangeEvent("hashchange"))},1000)
  }
  window.firstLaunch = false;
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js